import { AxiosResponse } from "axios";
import { _get, _aiTraceAsError } from "./BaseApiService";

const ID_CHECKS_API = "IdVerification/GetIdChecks";

/** Shape of a single ID check record returned by GetIdChecks. */
export interface IdCheckRow {
    status: string;
    providerId: string;
    provider: string;
    professionalName: string;
    contactName: string;
    contactNo: string;
    lastUpdatedOn: string;
    lastUpdatedBy: string;
     
    services?: string | string[] | null;
}

 
/** Local (client-side) services filter value matching rows that have no services. */
export const ID_CHECK_NO_SERVICES_FILTER = "__no_services__";

 
/**
 * Normalises the `services` attribute of an ID check row into a list of service names.
 * Accepts a comma-separated string or an array; returns an empty list when blank.
 */
export const getIdCheckServices = (row: IdCheckRow): string[] => {
    const raw = row?.services;
    const list = Array.isArray(raw) ? raw : typeof raw === "string" ? raw.split(",") : [];
    return list.map((service) => String(service ?? "").trim()).filter((service) => service.length > 0);
};

/**
 * Service for fetching ID verification check records.
 * Calls GET /api/IdVerification/GetIdChecks with optional filter parameters.
 */
class IDChecksService {
    /**
     * Retrieves ID check records, optionally filtered by check status.
     *
     * @param pendingIdChecks - Optional status filter for ID check results.
     */
    getIdChecks(pendingIdChecks?: string): Promise<AxiosResponse<any>> {
        const params = pendingIdChecks
            ? `?pendingIdChecks=${encodeURIComponent(pendingIdChecks)}`
            : "";
        return _get(ID_CHECKS_API + params);
    }

    /**
     * Forwards to AppInsights error tracing.
     * Exposed here so callers do not need to import BaseApiService directly.
     */
    traceAsErrorToAppInsights(message: string): boolean {
        return _aiTraceAsError(message);
    }
}

export default IDChecksService;
